import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";
import { JobIdProps } from "../interface/job_board";

export const apiGetJobs = async (filter: string, page: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/admin/jobs?page=${page}&${filter}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetJobId = async (data: JobIdProps) => {
  try {
    const uri = `/jobs/job/${data?.jobId}`;
    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetFacilityById = async (values: { jobId: string }) => {
  try {
    const uri = `/admin/jobs/${values.jobId}/job`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetJobStats = async () => {
  try {
    const uri = `/admin/jobs/job/stats`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetGeneralJobFacilityStats = async () => {
  try {
    const uri = `/admin/jobs/job/facility-stats`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetFacilityJobStats = async (values: { jobId: string }) => {
  try {
    const uri = `/admin/jobs/job/${values.jobId}/facility`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetApplicantionToJob = async (
  values: JobIdProps,
  page: string,
  filters: string,
) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/applications/${values.jobId}/facility?page=${page}&${filters}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiUpdateJobStatus = async (data: {
  status: string;
  jobId: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/admin/jobs/job/${data.jobId}`;
    formData.append("status", data?.status);
    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData.toString(), cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiDeleteJob = async (data: { jobId: string }) => {
  try {
    const uri = `/admin/jobs/${data.jobId}`;

    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.delete(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
